/**
 * Build the toast text for a failed voucher save, appending the backend's
 * validation detail so admins can see why the request was rejected.
 *
 * @param {Error} error - axios error from the save request.
 * @param {string} fallback - message shown when no detail is available.
 * @return {string}
 */
export function toVoucherErrorMessage(error, fallback) {
  const body = (error && error.response && error.response.data) || {}
  const { data, message, errorCode } = body

  let detail = null
  if (Array.isArray(data) && data.length > 0) {
    detail = data.join(", ")
  } else if (typeof message === "string" && message) {
    detail = message
  } else if (errorCode) {
    detail = errorCode
  }

  return detail ? `${fallback}: ${detail}` : fallback
}
